/**
 * Role-aware navigation map for the admin shell. `roles` gates visibility; an empty
 * array means "everyone signed in". Modules light up as their phase lands.
 */
import {
  LayoutDashboard,
  Users,
  UserSquare,
  FolderKanban,
  CheckSquare,
  Wallet,
  Heart,
  MessageSquareQuote,
  Inbox,
  FileBarChart,
  ScrollText,
  Settings,
  Upload,
} from 'lucide-react';

export const NAV_SECTIONS = [
  {
    title: 'Overview',
    items: [{ to: '/', label: 'Dashboard', icon: LayoutDashboard, roles: [] }],
  },
  {
    title: 'Casework',
    items: [
      { to: '/cases', label: 'Case pipeline', icon: FolderKanban, roles: [], phase: 2 },
      { to: '/beneficiaries', label: 'Beneficiaries', icon: UserSquare, roles: [], phase: 1 },
      { to: '/approvals', label: 'Approvals', icon: CheckSquare, roles: ['approver', 'senior_approver'], phase: 3 },
      { to: '/ledger', label: 'Disbursement ledger', icon: Wallet, roles: [], phase: 3 },
    ],
  },
  {
    title: 'Supporters',
    items: [
      { to: '/donors', label: 'Donors', icon: Heart, roles: [], phase: 6 },
      { to: '/testimonials', label: 'Testimonials', icon: MessageSquareQuote, roles: [], phase: 7 },
      { to: '/enquiries', label: 'Enquiries', icon: Inbox, roles: [] },
    ],
  },
  {
    title: 'Reporting',
    items: [
      { to: '/transparency', label: 'Transparency report', icon: FileBarChart, roles: [], phase: 7 },
      { to: '/audit', label: 'Audit trail', icon: ScrollText, roles: ['super_admin'], phase: 2 },
      { to: '/import', label: 'Bulk import', icon: Upload, roles: ['super_admin'], phase: 7 },
    ],
  },
  {
    title: 'Administration',
    items: [
      { to: '/users', label: 'Users', icon: Users, roles: ['super_admin'], phase: 1 },
      { to: '/settings', label: 'Settings', icon: Settings, roles: ['super_admin'], phase: 1 },
    ],
  },
];

/** Flattened list for the command palette + breadcrumb lookups. */
export const ALL_NAV_ITEMS = NAV_SECTIONS.flatMap((s) => s.items);
